import { skipToken, useQuery } from '@tanstack/react-query';

import { CustomFields } from '@air/api';
import { type Workspace } from '@air/api/types';

export const CUSTOM_FIELD_COLORS_LIST_KEY = '@plugin-ui/CUSTOM_FIELD_COLORS_LIST';

export type UseCustomFieldColorsParams = {
  workspaceId: Workspace['id'] | undefined;
};

export const useCustomFieldColors = ({ workspaceId }: UseCustomFieldColorsParams) => {
  return useQuery({
    queryFn: workspaceId ? () => CustomFields.listCustomFieldColors({ workspaceId }) : skipToken,
    queryKey: [CUSTOM_FIELD_COLORS_LIST_KEY, workspaceId],
    staleTime: Infinity,
  });
};
